// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "v2.56.0-2-g8f8f0811",
    "hash": "g8f8f0811",
    "distance": 2,
    "tag": "v2.56.0",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v2.56.0",
        "major": 2,
        "minor": 56,
        "patch": 0,
        "prerelease": [],
        "build": [],
        "version": "2.56.0"
    },
    "suffix": "2-g8f8f0811",
    "semverString": "2.56.0+2.g8f8f0811",
    "version": "2.4.1"
};
/* tslint:enable */
